var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Route',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('template',{slot:"title"},[_vm._v("\n\t\tProjects\n\t")]),_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }